/* @jsx h */
import { defineComponent, h, PropType } from "vue";
import { RouterLink } from "vue-router";
import type { GalleryAsset } from "../../../../api/client";
import type { ShopProfile } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";

export const RestaurantHeader = defineComponent({
  props: {
    restaurant: {
      type: Object as PropType<ShopProfile>,
      required: true,
    },
    gallery: {
      type: Array as PropType<GalleryAsset[]>,
      required: true,
    },
    placeholderImage: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <div class="mb-16">
        <nav class="mb-8">
          <div class="flex items-center text-sm text-gray-500 font-light">
            <RouterLink to="/" class="hover:text-gray-700">
              {t("customer.restaurant_profile.home")}
            </RouterLink>
            <span class="mx-2">/</span>
            <span class="text-gray-900">{props.restaurant.name}</span>
          </div>
        </nav>

        <div class="text-center mb-12">
          <h1 class="text-5xl md:text-6xl font-serif font-light text-gray-900 mb-6 leading-tight">
            {props.restaurant.name}
          </h1>

          <div class="flex items-center justify-center text-gray-500 mt-6">
            <span class="material-symbols-outlined text-lg mr-2">
              location_on
            </span>
            <span class="font-light">{props.restaurant.address}</span>
          </div>
        </div>

        {props.gallery.length > 0 && (
          <div class="mb-16">
            <div class="aspect-[16/9] overflow-hidden rounded-lg bg-gray-100">
              <img
                src={props.gallery[0]?.url || props.placeholderImage}
                alt={props.restaurant.name ?? t("customer.home.restaurant")}
                class="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).src = props.placeholderImage;
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  },
});
